import Vue from 'vue';
import {
  Pagination,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Button,
  Icon,
  Image,
  Loading,
  Message,
  MessageBox,
  Input,
  InputNumber,
  Progress,
  Table,
  TableColumn,
  Tag,
  Select,
  Option,
  Dialog,
  Form,
  FormItem,
  Radio,
  RadioButton,
  RadioGroup,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Tree,
  Breadcrumb,
  BreadcrumbItem,
  Cascader,
  DatePicker,
  TimePicker,
  Link,
} from 'element-ui';
import '@/scss/element-variables.scss';

Vue.use(Pagination);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Image);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Progress);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tag);
Vue.use(Select);
Vue.use(Option);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Radio);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Tree);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Cascader);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Link);

Vue.use(Loading.directive);

Vue.prototype.$loading = () => Loading.service({ body: true, background: 'transparent' });
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
